import type {JSX} from 'react';
import { useTranslations } from "~/hooks/useTranslations";

export function SoldOutTag(): JSX.Element {
  const t = useTranslations();

  return (
    <span className="flex flex-nowrap gap-4 items-center min-w-[100px] py-[1px] px-[8px] h-[24px] border border-[#CF1322] rounded-[4px]">
      <span className="inline-block w-2 h-2 bg-[#FF4D4F] rounded-full"></span>
      <span className="text-[14px]">{t.soldOutText}</span>
    </span>
  );
}
